export const base64WithPrefix = (base64: string) => {
  return `data:image/jpeg;base64,${base64}`;
};

export const base64WithoutPrefix = (base64: string) => {
  return base64.split(',')[1];
};

export function base64ToFile(base64: string, filename: string, mimeType: string) {
  const byteString = atob(base64); // remove "data:...;base64," prefix
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new File([ab], filename, { type: mimeType });
}

export function blobToBase64(blob: Blob) {
  return new Promise((resolve, _) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
}
